import React from 'react';
import { TaskCard } from '@medely/ui-kit';
import { TaskCardLayout } from './TaskCard';
import { useProNavigate } from '@mp/contexts';
import { useShiftSwaps } from '../jobs/shiftSwap/graphql';
import { useCurrentUser } from '@mp/hooks';

type ShiftSwapCardProps = {
  shiftRequestsNumber: number;
  name: string;
};

const SingleShiftSwapCard = ({ name, jobId }: { name: string; jobId?: number | null }) => {
  const { navigate } = useProNavigate();

  return (
    <TaskCardLayout>
      <TaskCard
        iconProps={{ name: 'light-arrows-repeat', color: 'info' }}
        title="Accept shift swap"
        body={`${name} would like to transfer an upcoming shift to you.`}
        onClick={() => navigate('JobDetails', { id: jobId as number })}
      />
    </TaskCardLayout>
  );
};

const MultipleShiftSwapCard = ({ shiftRequestsNumber }: { shiftRequestsNumber: number }) => {
  const { navigate } = useProNavigate();

  return (
    <TaskCardLayout>
      <TaskCard
        iconProps={{ name: 'light-calendar-day', color: 'primary' }}
        title="Shift requests"
        body={`You have ${shiftRequestsNumber} shift requests to review.`}
        onClick={() => navigate('ShiftSwaps')}
      />
    </TaskCardLayout>
  );
};

export const ShiftSwapCard = ({ name, shiftRequestsNumber }: ShiftSwapCardProps) => {
  const { currentUser } = useCurrentUser();
  const { shiftRequests } = useShiftSwaps({ accountId: currentUser?.id });

  const hasMoreThanOne = shiftRequestsNumber > 1;

  return hasMoreThanOne ? (
    <MultipleShiftSwapCard shiftRequestsNumber={shiftRequestsNumber} />
  ) : (
    <SingleShiftSwapCard name={name} jobId={shiftRequests?.[0]?.job_id} />
  );
};
